import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { TeachersAvailabilityApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseSpecialHoursGetProps {
  teacherId: number;
  page?: number;
  pageSize?: number;
  lastSelectedId?: number;
  active?: boolean;
}

export const useSpecialHoursGet = ({
  teacherId,
  page = 1,
  pageSize = 100,
  lastSelectedId,
  active,
}: IUseSpecialHoursGetProps) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, isFetching, refetch } =
    useQuery({
    queryKey: [
      QueryKeys.SpecialHours,
      teacherId,
      page,
      pageSize,
      lastSelectedId,
      active,
    ],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(
        TeachersAvailabilityApi,
        accessToken,
      );
      return service.apiAvailabilityTeacherIdSpecialAppointmentHoursGet({
        teacherId,
        page,
        pageSize,
        lastSelectedId,
        active,
      });
    },
    enabled: teacherId > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    refetch,
  };
};
